export default {
  async list(context, payload) {
    try {
      const response = await this.$api.call("section.list", payload);
      const responseData = response.data;
      context.commit("mutationSections", responseData);
      return response;
    } catch (error) {
      context.commit("mutationSections", []);
      throw error;
    }
  },
  async listForm(context, payload) {
    try {
      const response = await this.$api.call("section.list", payload);
      const responseData = response.data;
      context.commit("mutationSectionsForm", responseData);
      return response;
    } catch (error) {
      context.commit("mutationSectionsForm", []);
      throw error;
    }
  },
  async detail(context, payload) {
    try {
      const response = await this.$api.call("section.detail", payload);
      const responseData = response.data;
      context.commit("mutationSection", responseData);
      return response;
    } catch (error) {
      context.commit("mutationSection", {});
      throw error;
    }
  },
  async create(context, payload) {
    try {
      const response = await this.$api.call("section.create", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async edit(context, payload) {
    try {
      const response = await this.$api.call("section.edit", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async delete(context, payload) {
    try {
      const response = await this.$api.call("section.delete", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async resetListForm(context) {
    try {
      context.commit("mutationSectionsForm", []);
      return [];
    } catch (error) {
      context.commit("mutationSectionsForm", []);
      throw error;
    }
  },
};
